import { render } from "./assignRole.vue?vue&type=template&id=a7043f8a&scoped=true"
import script from "./assignRole.vue?vue&type=script&lang=js"
export * from "./assignRole.vue?vue&type=script&lang=js"

import "./assignRole.vue?vue&type=style&index=0&id=a7043f8a&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7043f8a"]])

export default __exports__